/**
 * Regelversion 7: Verfallene Entwürfe neu einbringen.
 *
 * Mit einer neuen Legislatur verfallen unfertige Gesetze (Diskontinuität). Eigene Entwürfe merkt sich das
 * Spiel aber: Ihr könnt sie mit denselben Einstellungen wieder öffnen, prüfen und neu ins Ministerium geben.
 * Das Verfahren beginnt dann von vorn.
 */
import { TPL } from '../content/issues';
import { S } from './state';
import { since } from './version';
import { coopGov, canDraft, busyOf } from './coalition';
import { capOf } from './adm';

export type Lapsed = { t: string; iss: string; tpl: number; p: any; stage: string };

/** Lässt sich der Entwurf gerade wieder einbringen? Grund, falls nicht. */
export function reDraftBlock(X: Lapsed): string | null {
  if (S.phase !== 'govern') return 'Erst wenn die Regierung im Amt ist.';
  const T = TPL(X.iss, X.tpl); if (!T) return 'Die Vorlage gibt es nicht mehr.';
  if (S.issues[X.iss]?.law) return 'Zu diesem Thema läuft schon ein Gesetz.';
  if (coopGov() && !canDraft('YOU', T)) return 'Das Ressort führt jetzt euer Partner.';
  if (busyOf('YOU') >= capOf('YOU')) return 'Eure Ministerien sind gerade ausgelastet.';
  return null;
}

/** Öffnet den Entwurf im Editor, mit den alten Einstellungen. */
export function reDraft(i: number) {
  if (!since(7)) return;
  const X: Lapsed | undefined = S.lapsed?.[i]; if (!X || reDraftBlock(X)) return;
  if (!S.issues[X.iss]) S.issues[X.iss] = { sev: 0, prev: 0, cut: 0, law: null, on: false } as any;
  S.editing = { iss: X.iss, tpl: X.tpl, lawId: null, p: JSON.parse(JSON.stringify(X.p)), from: i } as any;
}

/** Nach dem Einbringen: aus der Liste nehmen. */
export function reDraftDone(E: any) {
  if (!since(7) || E?.from == null || !S.lapsed) return;
  S.lapsed.splice(E.from, 1);
}
